import { RouteRecordRaw } from "vue-router";

import usePermissions from "@/hooks/use-permissions";
import AbtestLayerDialog from "@/pages/games/GameDisplay/children/abtests/components/AbtestLayerDialog/AbtestLayerDialog.vue";

import links from "./links";

const { canWriteAbtests } = usePermissions();

export default <RouteRecordRaw[]>[
  {
    path: "new",
    name: links.games.abtests.layers.new,
    component: AbtestLayerDialog,
    props: true,
    meta: {
      title: "New class",
      permission: canWriteAbtests,
    },
  },
  {
    path: ":layerId/edit",
    name: links.games.abtests.layers.edit,
    component: AbtestLayerDialog,
    props: true,
    meta: {
      title: "Edit class",
      permission: canWriteAbtests,
    },
  },
];
